/**
 * Công đoạn IPQC theo tên công đoạn của lệnh — một cách tính cho máy chủ và form IPQC (04/11/2026).
 * Không nhận ra công đoạn (vd Đóng gói) → '' (không nạp mẫu kiểm tra nào); trước đây mọi tên lạ rơi về In Offset.
 */
export function inferIpqcStage(stepName?: string | null, explicitStage?: string | null): string {
  if (explicitStage && String(explicitStage).trim()) return String(explicitStage).trim().toUpperCase();
  const s = String(stepName || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/đ/g, "d")
    .trim();
  if (!s) return "";
  if (/\b(dong goi|dong thung|dong kien|pack)/.test(s)) return "";
  if (/^in\b/.test(s) || s.includes("offset") || s.includes("flexo") || s.includes("print")) return "PRINTING";
  if (s.includes("cat") || s.includes("xa giay") || s.includes("cutting")) return "CUTTING";
  if (s.includes("can mang") || s.includes("laminat")) return "LAMINATING";
  if (s.includes("trang phu") || s.includes("uv") || s.includes("varnish") || s.includes("opv") || s.includes("coating")) return "COATING";
  if (s.includes("be") || s.includes("ep kim") || s.includes("dap noi") || s.includes("boi") || s.includes("die")) return "DIE_CUTTING";
  if (s.includes("dan") || s.includes("gap") || s.includes("glu")) return "GLUING";
  return "";
}
